import React from "react";
import {connect} from "react-redux";
import {Form, Formik} from "formik";
import {Button, Tab, Tabs} from "react-bootstrap";
import {productoActions, traerPalabrasTabla, utilActions} from "../../../_actions";
import {
    exportToCSV,
    history,
    MyToolTip,
    prepareDataSearch,
    ProductoDP,
    TIPO_EXPORT,
    TIPO_REPUESTO,
} from "../../../_helpers";
import {productoService} from "../../../_services";
import {buscadorConstants} from "../../../_constants";
import {busquedaActions} from "../../../_actions/busqueda.actions";
import MiTabla from "../../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavBarLateral} from "../NavBarLateral";
import { NumericFormat as NumberFormat } from "react-number-format";
import alertService from "../../../_services/cart/alert.service";
import FiltrosDashboard from "../../includes/FiltrosDashboard";
import productoServiceTs from "../../../_services/cart/producto.service";
import {ResumenPublicacionModal} from "../../includes/ResumenPublicacionModal";
import {buscadorService} from "../../../_services";

const tableRefActivas = React.createRef();
const tableRefFinalizadas = React.createRef();
const tableRefPausadas = React.createRef();
const bagRef = React.createRef();
const _ = require("lodash");

class ProductosVendedorList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        tipoKey: 'ACTIVA',
        loading: false,
        nuevaBusqueda: false,
        producto: {},
        /** La publicacion que se esta mirando en el resumen, o null si esta cerrado. */
        resumen: null,
        values: {},
        totalACTIVA: 0,
        totalFINALIZADA: 0,
        totalPAUSADA: 0
    };

    componentDidMount() {
        const {filtros} = this.props;

        if (filtros === undefined) this.props.traerFiltros();

        productoServiceTs.buscarTotalPublicaciones(this.setTotalesIniciales);
    }

    setTotalesIniciales = (newTotales) => {
        this.setState(newTotales);
    }

    handleClose = () => this.setState({show: false});

    handleShow = () => this.setState({show: true});

    actualizarFromTab = (tipoKey) => {
        if (tipoKey === 'ACTIVA') {
            if (tableRefActivas.current) {
                tableRefActivas.current.onQueryChange();
            }
        }

        if (tipoKey === 'FINALIZADA') {
            if (tableRefFinalizadas.current) {
                tableRefFinalizadas.current.onQueryChange();
            }
        }

        if (tipoKey === 'PAUSADA') {
            if (tableRefPausadas.current) {
                tableRefPausadas.current.onQueryChange();
            }
        }
    };

    actualizar = () => {
        if (this.state.tipoKey === 'ACTIVA') {
            if (tableRefActivas.current) {
                tableRefActivas.current.onQueryChange();
            }
        }

        if (this.state.tipoKey === 'FINALIZADA') {
            if (tableRefFinalizadas.current) {
                tableRefFinalizadas.current.onQueryChange();
            }
        }

        if (this.state.tipoKey === 'PAUSADA') {
            if (tableRefPausadas.current) {
                tableRefPausadas.current.onQueryChange();
            }
        }
    };

    actualizarPageSize = (newPageSIze) => {
        if (this.state.tipoKey === 'ACTIVA') {
            if (tableRefActivas.current) {
                tableRefActivas.current.dataManager.changePageSize(newPageSIze)
            }
        }

        if (this.state.tipoKey === 'FINALIZADA') {
            if (tableRefFinalizadas.current) {
                tableRefFinalizadas.current.dataManager.changePageSize(newPageSIze)
            }
        }

        if (this.state.tipoKey === 'PAUSADA') {
            if (tableRefPausadas.current) {
                tableRefPausadas.current.dataManager.changePageSize(newPageSIze)
            }
        }
    };

    handleCloseModal = () => {
        this.setState({
            producto: undefined,
            alert: undefined,
        });
    };

    buscarData = (query, booleano, status) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            let valuesToSend = this.state.values;
            valuesToSend.estado = status;

            productoService
                .buscar(prepareDataSearch(query, "id", "DESC", valuesToSend))
                .then(
                    (data) => {
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        let newState = {nuevaBusqueda: false};
                        newState['total' + status] = data.totalElements
                        this.setState(newState);
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };


    handleExportExcel = (fileName) => {
        this.buscarData(this.state.nuevo).then(
            (data) => {
                exportToCSV(
                    utilActions.listaParaExport(data, TIPO_EXPORT.CANDADO),
                    fileName
                );
            },
            (error) => {
                console.log("Error", error);
            }
        );
    };

    nuevoProducto = () => {
        history.push("/vendedor/addEditProducto");
    };

    editar = (producto) => {
        history.push("/vendedor/addEditProducto?id=" + producto.id);
    };

    ver = (producto) => {
        this.setState({resumen: producto});
    };

    cerrarResumen = () => {
        this.setState({resumen: null});
    };

    render() {
        const {filtros} = this.props;

        const {loading} = this.state;

        const tableStyle = {
            tableLayout: "auto",
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            borderRadius: "1rem",
            border: "1px solid #d2d2d2",
            boxShadow: 'none',
            backgroundColor: 'inherit',
            color: 'inherit'
        }

        const header = [
            {title: "ID", field: "id", cellStyle: { width: '2%' } },
            {
                title: "Tipo Repuesto", field: "tipoRepuesto.nombre",
                render: (row) =>
                    <>
                        {row.tipoRepuesto?.nombre}
                        {row.tipoRepuesto?.nombre === TIPO_REPUESTO.MOTOR_04 && <MyToolTip
                            texto={productoServiceTs.crearNombreMotorAsociados(row)}
                            id={row.id.toString()}
                        ></MyToolTip>}
                    </>
            },
            {title: "Marca", field: "marca.nombre"},
            {title: "Modelo", field: "modelo.nombre"},
            // Version / año / fecha de alta no entran en la card: quedan para escritorio.
            {title: "Version", field: "version.nombre", mobile: false},
            {title: "Año", field: "anio", cellStyle: { width: '4%' }, mobile: false},
            {title: "Estado", field: "estado"},
            {
                title: "Precio",
                field: "precio",
                // Sin precio el formateador pinta un "$" pelado y la fila parece un error de
                // carga: en el listado propio hay que poder distinguir "a consultar" de "me
                // olvide de poner el precio".
                render: (row) =>
                    productoActions.esPrecioAConsultar(row) ? (
                        <span>A consultar</span>
                    ) : (
                        <NumberFormat
                            prefix="$"
                            value={row.precio}
                            displayType={"text"}
                            thousandSeparator="."
                            decimalSeparator=","
                        />
                    ),
            },
            {
                title: "",
                cellStyle: {textAlign: "center"},
                render: (row) => (
                    <div className="table-button">
                        <Button
                            className="button"
                            data-type="complementary-smallest"
                            variant="primary"
                            onClick={() => this.ver(row)}
                            title="Ver resumen"
                            aria-label="Ver resumen de la publicación"
                        >
                            <FontAwesomeIcon icon="fa-solid fa-eye"/>
                        </Button>
                        <Button
                            className="button"
                            data-type="complementary-smallest"
                            variant="primary"
                            onClick={() => this.editar(row)}
                            title="Editar"
                            aria-label="Editar la publicación"
                        >
                            <FontAwesomeIcon icon="fa-solid fa-pen"/>
                        </Button>
                    </div>
                ),
            },
        ];

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            pageSize: 10,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };

        let inic = {
            marca: {id: undefined},
            modelo: {id: undefined},
            tipoRespuesto: {id: undefined},
        };

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Formik
                            enableReinitialize={true}
                            innerRef={bagRef}
                            initialValues={inic}
                            onSubmit={(values) => {
                                this.setState({values: values, nuevaBusqueda: true},
                                    this.actualizar
                                );
                            }}
                        >
                            {({values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <h2>Publicaciones</h2>
                                        </div>
                                    </div>

                                    <div className="filter__container">
                                        <div className="filterstart">
                                            <FiltrosDashboard
                                                forPublicacion={true}
                                                values={values}
                                                filtros={filtros}
                                                setFieldValue={setFieldValue}
                                                submitForm={submitForm}
                                            ></FiltrosDashboard>
                                        </div>
                                        <div className="filterend">
                                            <Button
                                                className="button"
                                                type="button"
                                                data-type="primary"
                                                onClick={() => this.nuevoProducto()}
                                            >
                                                Nueva publicación
                                            </Button>
                                        </div>

                                    </div>

                                    <Tabs
                                        mountOnEnter={true}
                                        id="controlled-tab-example"
                                        activeKey={this.state.tipoKey}
                                        onSelect={(k) => this.setState({
                                            tipoKey: k,
                                            nuevaBusqueda: true
                                        })}//, this.actualizarFromTab(k)
                                    >
                                        <Tab eventKey="ACTIVA" title={"Activas (" + this.state.totalACTIVA + ")"}>
                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefActivas}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'ACTIVA')}
                                                    detailPanel={(rowData) => {
                                                        return (
                                                            <ProductoDP rowData={rowData} editar={this.editar}/>
                                                        );
                                                    }}
                                                    localization={traerPalabrasTabla("PUblicación")}
                                                />
                                            </div>
                                        </Tab>

                                        <Tab eventKey="FINALIZADA"
                                             title={"Finalizadas (" + this.state.totalFINALIZADA + ")"}>

                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefFinalizadas}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'FINALIZADA')}
                                                    detailPanel={(rowData) => {
                                                        return (
                                                            <ProductoDP rowData={rowData} editar={this.editar}/>
                                                        );
                                                    }}
                                                    localization={traerPalabrasTabla("Publicación")}
                                                />
                                            </div>
                                        </Tab>

                                        <Tab eventKey="PAUSADA" title={"Pausadas (" + this.state.totalPAUSADA + ")"}>

                                            <div className="dashboard__content-main--tab">
                                                <MiTabla
                                                    title=""
                                                    tableRef={tableRefPausadas}
                                                    columns={header}
                                                    options={options}
                                                    style={tableStyle}
                                                    data={(query) => this.buscarData(query, false, 'PAUSADA')}
                                                    detailPanel={(rowData) => {
                                                        return (
                                                            <ProductoDP rowData={rowData} editar={this.editar}/>
                                                        );
                                                    }}
                                                    localization={traerPalabrasTabla("PUblicación")}
                                                />
                                            </div>
                                        </Tab>

                                    </Tabs>


                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>

                {this.state.resumen && (
                    <ResumenPublicacionModal
                        producto={this.state.resumen}
                        onHide={this.cerrarResumen}
                        onEditar={this.editar}
                        cargarDetalle={buscadorService.buscarProoductoPorIdAdmin}
                    />
                )}

                {this.state.alert}
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {
    traerFiltros: busquedaActions.traerFiltros,
};

const connectedProductosVendedorList = connect(
    mapState,
    actionCreators
)(ProductosVendedorList);
export {connectedProductosVendedorList as ProductosVendedorList};
